import { WidgetSchema } from '@/entities/widget';

import { Header, Heading } from '@/shared/ui';

import { SlideCard } from './SlideCard';

export const ComingSoonWidget = ({ widget }: { widget: WidgetSchema }) => {
  return (
    <SlideCard className="relative items-start">
      <Header className="pb-6" title={widget.label} />

      <Heading className="absolute top-[50%] translate-y-[-50%]">
        Coming soon
      </Heading>
    </SlideCard>
  );
};
